export default __webpack_public_path__ + "static/slide-01-0c84a16fd071fb470dad8eebcc60842e.jpg";